module.exports = __webpack_public_path__ + "static/media/womens-watches.8b5e41d9.png";